import * as React from "react";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const SupplierAssign = React.lazy(() => import("./SupplierAssign"));
const Suppliers = React.lazy(() => import("./Suppliers"));
const SupplierView = React.lazy(() => import("./SupplierView"));
const SupplierEdit = React.lazy(() => import("./SupplierEdit"));
const SupplierCreate = React.lazy(() => import("./SupplierCreate"));
const SuppliersMerge = React.lazy(() => import("./Merge/SuppliersMerge"));

export default function SupplierIndex(): Array<React.ReactNode> {
    return [
        <PermissionRoute
            title="Suppliers | Shopfront"
            permissions={[ "see_suppliers" ]}
            path="/suppliers"
            key="suppliers"
            element={<Suppliers />}
        />,
        <PermissionRoute
            title="Create Supplier | Shopfront"
            permissions={[ "create_suppliers" ]}
            path="/supplier/create"
            key="supplier-create"
            element={<SupplierCreate />}
        />,
        <PermissionRoute
            title="Assign Supplier | Shopfront"
            permissions={[ "edit_products" ]}
            path="/supplier/:id/assign"
            key="supplier-assign"
            element={<InjectRouteParams route={SupplierAssign} />}
        />,
        <PermissionRoute
            title="View Supplier | Shopfront"
            permissions={[ "see_suppliers" ]}
            path="/supplier/:id"
            key="supplier-view"
            element={<InjectRouteParams route={SupplierView} />}
        />,
        <PermissionRoute
            title="Edit Supplier | Shopfront"
            permissions={[ "see_suppliers" ]}
            path="/supplier/:id/edit"
            key="supplier-edit"
            element={<InjectRouteParams route={SupplierEdit} />}
        />,
        <PermissionRoute
            permissions={[ "see_suppliers", "edit_suppliers" ]}
            title="Merge Suppliers | Shopfront"
            path="/suppliers/merge"
            key="suppliers-merge"
            element={<SuppliersMerge />}
        />,
    ];
}
